<!-- 组件说明 -->
<template>
    <el-dialog
        title="提示"
        :custom-class="'pluginVideo'"
        :visible.sync="dialogVisible"
        width="680px"
        append-to-body
        :before-close="beforeClose"
    >
        <div>
            <p v-if="isNeedTips" class="mb20 font18">检测到您未安装插件，店铺诊断须安装插件才能使用</p>
            <video width="100%" height="400px" controls id="pluginVideo" ref="video" muted>
                <source
                    src="https://cloud.video.taobao.com/play/u/2216950060407/p/2/e/6/t/1/458563757384.mp4"
                    type="video/mp4"
                />
            </video>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirm">下载插件</el-button>
        </span>
    </el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    props: {
        isNeedTips: {
            type: Boolean,
            default: true,
        },
    },
    components: {},
    data() {
        return {
            dialogVisible: false,
        };
    },
    //监控data中的数据变化
    watch: {},
    //监听属性 类似于data概念
    computed: {},
    methods: {
        show() {
            this.dialogVisible = true;
        },

        beforeClose() {
            this.dialogVisible = false;
        },

        confirm() {
            window.open('https://oss.fjdaze.com/tools/aliToolsPlugins/integrated-plugin/integrated-plugin.zip');
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
};
</script>

<style lang="scss" scoped>
//@import url()
</style>
